import { useState } from 'react'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'

interface IProps {
  kitchenName: string
  windowName: string
  ordered: number
  closeModal: () => void
  onSubmit: (served: number, standbyUsed: number, onBehalf: boolean) => void
}

export const KitchenConfirmationModal = ({ kitchenName, windowName, ordered, closeModal, onSubmit }: IProps) => {
  const [served, setServed] = useState(String(ordered))
  const [standbyUsed, setStandbyUsed] = useState('0')
  const [onBehalf, setOnBehalf] = useState(false)
  useModalClose(closeModal)

  const valid = served.trim() && Number(served) >= 0

  return (
    <Modal black width='520px'>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center>
          <TitleText weight='bold'>
            Kitchen Confirmation — {kitchenName} · {windowName}
          </TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <OtherText grey>Ordered (locked at cut-off): {ordered}</OtherText>
        <Flex gap='1rem' width='100%'>
          <Input
            type='number'
            labelText='Served count'
            placeholder='Enter served count'
            value={served}
            onChange={(e: any) => setServed(e.target.value)}
            nomarg
          />
          <Input
            type='number'
            labelText='Standby used'
            placeholder='Enter standby used'
            value={standbyUsed}
            onChange={(e: any) => setStandbyUsed(e.target.value)}
            nomarg
          />
        </Flex>
        <CheckBox
          square
          state={onBehalf}
          onClick={() => setOnBehalf(!onBehalf)}
          title='Entered on behalf of the kitchen (offline / contractor without access) — audited'
        />
        <Flex gap='0.5rem' justcenter width='100%'>
          <Button onClick={closeModal}>Cancel</Button>
          <Button
            orange
            disabled={!valid}
            onClick={() => onSubmit(Number(served), Number(standbyUsed || 0), onBehalf)}
          >
            Submit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
